(function () {
  function setup(root) {
    if (!root || root.dataset.cargrowFiltersReady === 'true') return;
    root.dataset.cargrowFiltersReady = 'true';

    var state = { type: 'all' };

    function apply() {
      var items = document.querySelectorAll('#product-grid > li[data-cargrow-profile]');
      var visible = 0;
      items.forEach(function (item) {
        var show = state.type === 'all' || item.dataset.cargrowProfile === state.type || item.dataset.cargrowRange === state.type;
        item.hidden = !show;
        if (show) visible += 1;
      });

      var count = root.querySelector('[data-cargrow-filter-count]');
      if (count) count.textContent = visible + (visible === 1 ? ' produs' : ' produse');
      document.querySelectorAll('#ProductCountDesktop, #ProductCount').forEach(function (status) {
        status.textContent = visible + (visible === 1 ? ' produs afișat' : ' produse afișate');
      });

      var empty = document.querySelector('[data-cargrow-filter-empty]');
      if (!empty && items.length && visible === 0) {
        empty = document.createElement('p');
        empty.dataset.cargrowFilterEmpty = 'true';
        empty.className = 'cargrow-filter-empty';
        empty.textContent = 'Nu există produse pentru combinația aleasă.';
        var grid = document.getElementById('product-grid');
        if (grid) grid.parentNode.appendChild(empty);
      }
      if (empty) empty.hidden = visible !== 0;
    }

    document.addEventListener('click', function (event) {
      var button = event.target.closest('[data-cargrow-filter-value]');
      if (!button || !root.contains(button) || button.disabled) return;
      state.type = button.dataset.cargrowFilterValue;
      root.querySelectorAll('[data-cargrow-filter-value]').forEach(function (chip) {
        var active = chip === button;
        chip.classList.toggle('is-active', active);
        chip.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
      apply();
    });

    apply();
  }

  function boot() {
    setup(document.querySelector('[data-cargrow-quick-filters]'));
  }

  document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);
})();
